export const SET_LEADS_STATUSES = "SET_LEADS_STATUSES";
export const DELETE_LEADS_STATUS = "DELETE_LEADS_STATUS";
